const rubros = ["Pizzerías", "Cafeterías", "Hamburgueserías", "Heladerías", "Tiendas de ropa", "Barberías", "Peluquerías", "Kioscos", "Dietéticas", "Consultorios", "Veterinarias", "Panaderías"];

// Franja de rubros que se desliza con el scroll.
const Marquee = () => {
  return (
    <div className="lp-marquee" aria-label="Rubros que usan MiQRapp">
        <div className="lp-marquee-track" data-scroll>
            {
                [...rubros, ...rubros].map((rubro, i) => (
                    <span key={i} aria-hidden={i >= rubros.length}>{rubro}<i aria-hidden="true">✦</i></span>
                ))
            }
        </div>
    </div>
  )
}

export default Marquee
